/* eslint-disable camelcase */
import axios from 'axios';

import { useServicerStore } from '../store';

const BorrowerService = {
  async searchBorrowers({ query, lenderId }) {
    const response = await axios.get('/search/borrowers', {
      params: {
        query,
        servicer_id: useServicerStore.getState()?.servicerId,
        lender_id: lenderId,
      },
    });

    return response.data;
  },

  async getBorrower(borrowerId) {
    const response = await axios.get(`/borrower/${borrowerId}`);

    return response.data;
  },

  async getBorrowers() {
    const response = await axios.get('/borrower', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
      },
    });

    return response.data;
  },

  async createBorrower({ formValues, loanId }) {
    const values = {
      ...formValues,
      loan_id: loanId,
      servicer_id: useServicerStore.getState()?.servicerId,
    };

    const response = await axios.post('/borrower', values);

    return response.data;
  },

  async updateBorrower({ formValues, borrowerId }) {
    const values = {
      ...formValues,
      servicer_id: useServicerStore.getState()?.servicerId,
    };

    const response = await axios.put(`/borrower/${borrowerId}`, values);

    return response.data;
  },
};

export default BorrowerService;
